/**
 *  @class
 *  @function BrandRecommendations
 */
if (!customElements.get('brand-recommendations')) {
  class BrandRecommendations extends HTMLElement {
    constructor() {
      super();

      this.container = this.querySelector('[data-brand-recommendations-list]');
      // The product being viewed, or the products already in the cart
      this.excludeIds = (this.dataset.excludeIds || '').split(',');
      this.max = parseInt(this.dataset.limit, 10) || 4;
      this.poolSize = parseInt(this.dataset.poolSize, 10) || 20;
      // Set in the cart drawer, which slides the recommendations panel out once it has products
      this.parent = this.closest('.product-recommendations--parent');
    }
    connectedCallback() {
      this.fetchProducts();
    }
    fetchProducts() {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;

          // Pool: the first in-stock products of the brand collection, without the excluded products
          const pool = Array.from(html.querySelectorAll('[data-brand-recommendations-list] > [data-product-id]'))
            .filter(item => !this.excludeIds.includes(item.dataset.productId))
            .slice(0, this.poolSize);
          const picks = this.pickRandom(pool, this.max);

          if (picks.length) {
            this.container.innerHTML = picks.map(item => item.outerHTML).join('');
            this.classList.add('product-recommendations--loaded');

            if (this.parent) {
              this.parent.classList.add('product-recommendations--full');

              if (OverlayManager.isOpen(document.getElementById('Cart-Drawer'))) {
                this.parent.classList.add('active');
              }
            }
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
    pickRandom(items, count) {
      // Fisher-Yates shuffle, stopped once enough items are drawn
      const pool = items.slice();
      const total = Math.min(count, pool.length);

      for (let i = 0; i < total; i++) {
        const j = i + Math.floor(Math.random() * (pool.length - i));
        [pool[i], pool[j]] = [pool[j], pool[i]];
      }
      return pool.slice(0, total);
    }
  }

  customElements.define('brand-recommendations', BrandRecommendations);
}
